let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9Z3Uz")).then(() => parcelRequire('8zm0a'));